import type { Location } from 'history'
import qs from 'qs'

/**
 * When React hooks ship to production, we can replace this
 */
export function getUrlQuery<T>(args: { location: Location<any> }) {
  return qs.parse(args.location.search.substring(1, args.location.search.length)) as unknown as T
}
